export default "__VITE_ASSET__c1b769f3__"